module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 78.5c09e046.png";